import { render, staticRenderFns } from "./DTSignatoryModal.vue?vue&type=template&id=cfe45b9c&"
import script from "./DTSignatoryModal.vue?vue&type=script&lang=js&"
export * from "./DTSignatoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports